export const mapAisVersion = (data) => {
  const { number, name, enabled, aisVersion, aisVersionCheckedAt } = data;

  return {
    number,
    name,
    enabled,
    aisVersion: aisVersion || null,
    aisVersionCheckedAt: aisVersionCheckedAt || null,
  };
};
